import moment from 'moment';
import { IVehicle, IVehiclesChecklist } from '@common/interfaces';
import { IVehicleChecklistScheduler } from '../components/VehiclesChecklistCalendar';

export default class Serializer {
  public static mapVehiclesForScheduler(
    vehicles: IVehicle[],
    checklists: IVehiclesChecklist[],
  ): IVehicleChecklistScheduler[] {
    const CHECKLIST_DATE_FORMAT = 'DD/MM/YYYY';

    return vehicles.map((vehicle) => {
      let criticalIssue: { start: string; end: string } | null = null;
      const criticalVehicleChecklists = checklists.filter(
        (c) => c.vehicle_id === vehicle.id && c.critical_issues_count > 0,
      );

      if (criticalVehicleChecklists.length) {
        criticalIssue = {
          start: moment(criticalVehicleChecklists[0].created, CHECKLIST_DATE_FORMAT).toString(),
          end: moment(criticalVehicleChecklists[0].created, CHECKLIST_DATE_FORMAT).toString(),
        };

        for (let i = 1; i < criticalVehicleChecklists.length; i += 1) {
          const previousCriticalChecklist = moment(
            criticalVehicleChecklists[i - 1].created,
            CHECKLIST_DATE_FORMAT,
          );
          const nextCriticalChecklist = moment(
            criticalVehicleChecklists[i].created,
            CHECKLIST_DATE_FORMAT,
          );

          if (nextCriticalChecklist.isSame(previousCriticalChecklist.add(1, 'day'))) {
            criticalIssue.end = moment(criticalVehicleChecklists[i].created).toString();
          }
        }
      }

      return {
        ...vehicle,
        key: String(vehicle.id),
        ...(criticalIssue ? { criticalIssue } : {}),
      };
    });
  }

  public static mapChecklistsForScheduler(checklists: IVehiclesChecklist[]): IVehiclesChecklist[] {
    const CHECKLIST_DATE_FORMAT = 'DD/MM/YYYY';

    return checklists.map((checklist) => ({
      ...checklist,
      start_date: moment(checklist.created, CHECKLIST_DATE_FORMAT).startOf('day').toDate(),
      end_date: moment(checklist.created, CHECKLIST_DATE_FORMAT).endOf('day').toDate(),
      vehicle: checklist.vehicle_id,
      is_hide: false,
    }));
  }
}
